import {
    Component,
    OnInit,
    AfterViewInit,
    ViewChild,
    TemplateRef,
    ChangeDetectorRef,
    ViewContainerRef,
    NgModuleRef,
    Injector,
    Compiler,
    ElementRef
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
    CclNavbarSecondaryService,
    CclList,
    CclListColumn,
    CclTemplateResolverService,
    CclListTemplateProviderComponent,
    CclListTemplates,
    CclListColumnSize,
    CclMessageService,
    CclNavbarFooterService,
    CclRouteTab,
    CclDrawerService,
    CclNotifyService,
    CclPopupService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { ListService } from "../../../list-service";
import { cloneDeep } from "lodash";
import { isEqual } from "lodash";
import { SessionService } from "../../../../../modules/shared/services/session-service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { Subscription } from "rxjs";
import * as mustache from "mustache";
import { FlashMessagesService } from "angular2-flash-messages";
import { AttendeeSessionService } from "../../../../../modules/shared/services/attendee-session.service";
import { NgxSmartModalService } from "ngx-smart-modal";
import { DatePipe } from "@angular/common";
import { SessionSectionView } from "../../../../../views/attendee-feature";
import { CookieService } from "ngx-cookie";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";
import { SpeakerService } from "../../../../../modules/shared/services/speaker.service";

@Component({
    selector: "app-general-page",
    templateUrl: "./general-page.view.html",
    styleUrls: []
})
export class GeneralPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    topLevelIndex;
    mustache = mustache;
    sessionConfigObj: any;
    speakerDataConfig: any = {};
    remainingLevel: any;
    speakerDefaultGroupConfig: any = {};
    previewOnAdmin: any;

    @ViewChild("generalList", { read: ViewContainerRef })
    generalList: ViewContainerRef;

    sessionFilterSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "item_text",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true
    };

    speakerTypeDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "name",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    today: any = new Date();
    groupOn: any = {
        topLevel: [
            {
                label: "Speaker Type",
                code: "speakerTypeName"
            },
            {
                label: "Organization",
                code: "organization"
            }
        ]
    };

    sortOn: any = {
        topLevel: [
            {
                label: "Speaker First Name",
                code: "fname"
            },
            {
                label: "Speaker Last Name",
                code: "lname"
            },
            {
                label: "Organization",
                code: "organization"
            },
            {
                label: "Position",
                code: "position"
            },
            {
                label: "Speaker Rank",
                code: "speakerRank"
            },
        ]
    };

    sortOrder = [
        {

            label: 'Ascending',
            code: 'asc'
        },
        {
            label: 'Descending',
            code: 'desc'
        }
    ];

    groupTemplate: any = {
        group: [
            {
                label: " Grouping Style 1: Speaker Type -> Speaker First Name",
                code: "group1",
                topLevel: {
                    sortingBy: "fname",
                    groupingBy: "speakerTypeName",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                }
            }
        ]
    };

    defaultData: boolean = false;

    defaultSpeakerData: any = {
        completeCollectionSize: 4,
        size: 4,
        maxResults: 4,
        startingIndex: 0,
        speakers: [
            {
                id: 6316,
                sessionId: null,
                userName: null,
                firstName: "Mark",
                eventCode: "Flexicode-10150-49037",
                lastName: "Penn",
                email: null,
                profilePicURL: "",
                prefix: null,
                position: "",
                organization: "The A Inc.",
                suffix: null,
                speakerId: "6316",
                eventId: "567",
                pkEventId: null,
                profileUniqId: null,
                externalUniqId: null,
                pin: null,
                middleName: null,
                badgeName: null,
                gender: null,
                phone: null,
                mobile: null,
                fax: null,
                webAddress: null,
                faceBook: null,
                google: null,
                twitter: null,
                bio: null,
                sessionName: null,
                startDate: null,
                endDate: null,
                locationName: null,
                notes: null,
                dateCreated: null,
                dateModified: null,
                speakerDob: null,
                speakerType: "Speaker Type 1",
                linkedin: null,
                appCode: "certain",
                domain: "dev"
            },
            {
                id: 6317,
                sessionId: null,
                userName: null,
                firstName: "Felicity",
                eventCode: "Flexicode-10150-49037",
                lastName: "Thomson",
                email: null,
                profilePicURL: "",
                prefix: null,
                position: "",
                organization: "Dicers",
                suffix: null,
                speakerId: "6317",
                eventId: "567",
                pkEventId: null,
                profileUniqId: null,
                externalUniqId: null,
                pin: null,
                middleName: null,
                badgeName: null,
                gender: null,
                phone: null,
                mobile: null,
                fax: null,
                webAddress: null,
                faceBook: null,
                google: null,
                twitter: null,
                bio: null,
                sessionName: null,
                startDate: null,
                endDate: null,
                locationName: null,
                notes: null,
                dateCreated: null,
                dateModified: null,
                speakerDob: null,
                speakerType: "Speaker Type 1",
                linkedin: null,
                appCode: "certain",
                domain: "dev"
            },
            {
                id: 6315,
                sessionId: null,
                userName: null,
                firstName: "Robert",
                eventCode: "Flexicode-10150-49037",
                lastName: "Park",
                email: null,
                profilePicURL: "",
                customFields: null,
                customFieldMap: {
                    worked: "Jeep",
                    car: "no",
                    textField: "111"
                },
                prefix: null,
                position: "",
                organization: "Amber",
                suffix: null,
                speakerId: "6315",
                eventId: "567",
                pkEventId: null,
                profileUniqId: null,
                externalUniqId: null,
                pin: null,
                middleName: null,
                badgeName: null,
                gender: null,
                phone: null,
                mobile: null,
                fax: null,
                webAddress: null,
                faceBook: null,
                google: null,
                twitter: null,
                bio: null,
                sessionName: null,
                startDate: null,
                endDate: null,
                locationName: null,
                notes: null,
                dateCreated: null,
                dateModified: null,
                speakerDob: null,
                speakerType: "Speaker Type 2",
                linkedin: null,
                appCode: "certain",
                domain: "dev"
            },
            {
                id: 6314,
                sessionId: null,
                userName: null,
                firstName: "Shaun",
                eventCode: "Flexicode-10150-49037",
                lastName: "Cal",
                email: null,
                profilePicURL: "",
                prefix: null,
                position: "",
                organization: "F&G Inc.",
                suffix: null,
                speakerId: "6314",
                eventId: "567",
                pkEventId: null,
                profileUniqId: null,
                externalUniqId: null,
                pin: null,
                middleName: null,
                badgeName: null,
                gender: null,
                phone: null,
                mobile: null,
                fax: null,
                webAddress: null,
                faceBook: null,
                google: null,
                twitter: null,
                bio: null,
                sessionName: null,
                startDate: null,
                endDate: null,
                locationName: null,
                notes: null,
                dateCreated: null,
                dateModified: null,
                speakerDob: null,
                speakerType: "Speaker Type 2",
                linkedin: null,
                appCode: "certain",
                domain: "dev"
            }
        ]
    };

    sortCase;
    speakerPreviewData: any = {};
    generalSessionConfig;
    sessions: CclList = <CclList>{ pagination: {} };

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private catalogService: CatalogService,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService,
        private _flashMessagesService: FlashMessagesService,
        private drawerService: CclDrawerService,
        private router: Router,
        private attendeeSessionService: AttendeeSessionService,
        private sessionService: SessionService,
        private compiler: Compiler,
        private injector: Injector,
        private moduleRef: NgModuleRef<any>,
        private datePipe: DatePipe,
        public ngxSmartModalService: NgxSmartModalService,
        private notifyService: CclNotifyService,
        private cookieService: CookieService,
        private popupService: CclPopupService,
        private speakerService: SpeakerService,
        private elementRef: ElementRef
    ) {
        super(sharedService);
        this.previewOnAdmin = new SessionSectionView(
            navSecondaryService,
            sharedService,
            router,
            attendeeSessionService,
            compiler,
            injector,
            moduleRef,
            datePipe,
            ngxSmartModalService,
            messageService,
            notifyService,
            cookieService,
            _flashMessagesService,
            popupService,
            speakerService,
            sessionService,
            elementRef
        );

        this.navSecondaryService.sectionLabel = "Data";
        this.remainingLevel = 2;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSessionConfig(message));
        this.sharedService.renderViewSubject.subscribe((value) => {
            if (value) {
                this.renderView();
                this.sharedService.generalPreviewRefRender = false;
            }
        });

        this.sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.DATA["general"]];
        if (this.sessionConfigObj == null || this.sessionConfigObj.id == null) {
            this.speakerDataConfig = cloneDeep(this.sharedService.dataConfig["general"]);
            this.sessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.DATA["general"]
            };
        } else {
            this.speakerDataConfig = JSON.parse(this.sessionConfigObj.config);

            if (this.speakerDataConfig.hasOwnProperty("defaultFilters")) {
                if (!this.speakerDataConfig.defaultFilters.hasOwnProperty("speakerTypes")) {
                    this.speakerDataConfig.defaultFilters.speakerTypes = [];
                }
            } else {
                this.speakerDataConfig["defaultFilters"] = {
                    speakerTypes: []
                };
            }

            if (this.speakerDataConfig["topLevel"].active) {
                this.topLevelIndex = this.groupOn.topLevel.findIndex(
                    (record) => record.code === this.speakerDataConfig.topLevel.groupingBy
                );
            }
            this.remainingLevel = 0;
            var filter = {};
            filter["limit"] = 10;
            filter["page"] = 0;
            filter["section"] = this.sharedService.configTypes.SPEAKER.general;

            this.speakerService.getSpeakersEs(filter).subscribe((resp) => {
                if (resp.body != null && resp.body["speakers"].length > 0) {
                    this.speakerPreviewData = resp.body["speakers"];
                    this.defaultData = false;
                    let e = {
                        groupValue: this.speakerDataConfig.topLevel.groupingBy,
                        sortValue: this.speakerDataConfig.topLevel.sortingBy
                    };
                    this.valueChangeEvent(e, "group", true);
                } else {
                    this.speakerPreviewData = this.defaultSpeakerData.speakers;
                    this.defaultData = true;
                    let e = {
                        groupValue: this.speakerDataConfig.topLevel.groupingBy,
                        sortValue: this.speakerDataConfig.topLevel.sortingBy
                    };
                    this.valueChangeEvent(e, "group", true);
                }
            });
        }

        if(!this.speakerDataConfig.hasOwnProperty('sort')) {
            this.speakerDataConfig.sort = {}
            this.speakerDataConfig.sort.sortOrder = 'asc';
        }

        this.sharedService.speakerEnumCustomFields.forEach((element) => {
            if(element.questionTypeId == 4 || element.questionTypeId == 6) {
                this.groupOn.topLevel.push({
                    'label': element.name,
                    'code': element.code
                })
            }
        });

        this.sharedService.speakerCustomFields.forEach(element => {
            if(element.questionTypeId == 1 || element.questionTypeId == 4 || element.questionTypeId == 6) {
                this.sortOn.topLevel.push({
                    'label': element.name,
                    'code': element.code
                })
            }
        });

         // For checking unsaved data
         this.speakerDataConfig.selectedList = [];
         this.sharedService.originalData = cloneDeep(this.speakerDataConfig);
         this.sharedService.changedData = this.speakerDataConfig;
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.previewCss();
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Additional Settings";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-general-session";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-general-next-session";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    previewGroup() {
        this.sharedService.loadingList = true;
        if (this.updateStyle && this.speakerDefaultGroupConfig.topLevel == undefined) {
            this.previewOnAdmin.fromAttedee(this.speakerPreviewData, this.speakerDataConfig);
            return;
        }
        if (
            this.speakerDefaultGroupConfig.topLevel.groupingBy != null &&
            this.speakerDefaultGroupConfig.topLevel.groupingBy != undefined
        ) {
            this.speakerDataConfig.topLevel["active"] = true;
        }

        if (this.speakerDefaultGroupConfig.dateTimeFormats == undefined) {
            this.speakerDefaultGroupConfig["dateTimeFormats"] = {
                dateFormat: "EEEE, MMMM dd",
                timeFormat: "hh:mm a"
            };
        }

        if (this.speakerDefaultGroupConfig.topLevel.textConfig == undefined || this.updateStyle) {
            if (
                this.speakerDataConfig.topLevel.textConfig != undefined &&
                this.speakerDataConfig.topLevel.textConfig != null
            ) {
                this.speakerDefaultGroupConfig.topLevel["textConfig"] = this.speakerDataConfig.topLevel.textConfig;
            } else {
                this.speakerDefaultGroupConfig.topLevel["textConfig"] = {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                };
            }
        }
        {
            this.updateStyle = false;
            this.previewOnAdmin.fromAttedee(this.speakerPreviewData, this.speakerDefaultGroupConfig);
        }
    }

    renderView() {
        this.generalList.clear();
        this.generalList.insert(this.sharedService.generalPreviewRef.hostView);
    }

    valueChangeGroup(e) {
        var group = e.value;
        var ind;
        ind = this.groupTemplate.group.findIndex((record) => record.code === e.value);
        this.speakerDataConfig.group = group;
        this.speakerDefaultGroupConfig = this.groupTemplate.group[ind];
        this.previewGroup();
    }

    valueChangeEvent(e, level, init) {
        if (init) {
            this.speakerDataConfig.topLevel.groupingBy = e.groupValue;
            this.speakerDataConfig.topLevel.sortingBy = e.sortValue;
            this.speakerDefaultGroupConfig["topLevel"] = {
                ["sortingBy"]: e.sortValue,
                ["groupingBy"]: e.groupValue
            };
        } else {
            if (level == "group") {
                this.topLevelIndex = this.groupOn.topLevel.findIndex((record) => record.code === e.value);
                this.speakerDataConfig.topLevel.groupingBy = e.value;
                this.speakerDefaultGroupConfig["topLevel"] = {
                    ["groupingBy"]: e.value,
                    ["sortingBy"]: this.speakerDataConfig.topLevel.sortingBy
                };
            } else if (level == "sort") {
                this.topLevelIndex = this.sortOn.topLevel.findIndex((record) => record.code === e.value);
                this.speakerDataConfig.topLevel.sortingBy = e.value;
                this.speakerDefaultGroupConfig["topLevel"] = {
                    ["sortingBy"]: e.value,
                    ["groupingBy"]: this.speakerDataConfig.topLevel.groupingBy
                };
            }
        }

        this.remainingLevel = 0;
        this.previewGroup();
    }

    updateStyle: boolean = false;

    saveSessionConfig(message) {
        this.speakerDataConfig.selectedList = this.speakerDataConfig.selectedList;
        if (message.text == "save-general-session" || message.text == "save-general-next-session") {
            if(this.speakerDataConfig.topLevel.groupingBy == this.speakerDataConfig.topLevel.sortingBy) {
                this._flashMessagesService.show("Sorting value must be different from grouping value", {
                    cssClass: "alert-danger"
                });
                return; 
            }
            delete this.speakerDataConfig.group;
            this.sessionConfigObj.config = JSON.stringify(this.speakerDataConfig);
            this.catalogService.saveSetupConfig(this.sessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.speakerDataConfig);
                this.sharedService.changedData = this.speakerDataConfig;
                this.sharedService.loadingList = true;
                this.sharedService.createCss(this.catalogService);

                this.sessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.DATA["general"]] = this.sessionConfigObj;
                this._flashMessagesService.show("General Data Speaker layout saved successfully.", {
                    cssClass: "alert-success"
                });
                setTimeout(() => {
                    this.sharedService.loadingList = false
                }, 7000 );
                if (message.text == "save-general-next-session") {
                    this.sharedService.currentLayoutSection = "additional-setting";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/add-setting/additional-setting");
                }
            });
        } else if (message.text == "apply-grouping-display-config") {
            if (this.sharedService.dataConfig["general"].topLevel.active) {
                if (!this.sharedService.dataConfig["general"].topLevel.textConfig.fontColor) {
                    this.sharedService.dataConfig["general"].topLevel.textConfig.fontColor = "#0d2958";
                }
                if (!this.sharedService.dataConfig["general"].topLevel.textConfig.fontSize) {
                    this.sharedService.dataConfig["general"].topLevel.textConfig.fontSize = 14;
                }
            }
            this.speakerDataConfig = cloneDeep(this.sharedService.dataConfig["general"]);
            this.sharedService.changedData = this.speakerDataConfig;
            this.drawerService.hideDrawer();
            this.updateStyle = true;
            this.previewGroup();
            this.previewCss();
        }
    }

    previewCss() {
        $("#preview-general-data-speaker").remove();
        $(
            `<style id="preview-general-data-speaker">${this.sharedService.createCssGeneralData({
                config: JSON.stringify(this.speakerDataConfig)
            })}</style>`
        ).appendTo("body");
    }

    openConfigDrawer(item) {
        this.sharedService.currentDrawer = {
            title: "Edit Grouping display",
            navLinks: null,
            saveMessage: "apply-grouping-display-config"
        };
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "grouping-display-config") {
            this.sharedService.dataConfig["general"] = cloneDeep(this.speakerDataConfig);
            url = "config-drawer/grouping/customize-display";
        }
        this.sharedService.navigateToOutlet("drawer", url );
    }
}
